var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"text-success"},[_vm._v("\n    "+_vm._s(_vm._f("setText")("device_in_control","Устройство на контроле"))+"\n  ")]),_c('h5',[_vm._v(_vm._s(_vm._f("setText")("go_next","Вы можете продолжить оформление")))])])}
var staticRenderFns = []

export { render, staticRenderFns }